/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * The different sex options
 */
enum Sexe {
  Homme = 'homme',
  Femme = 'femme',
  /** Même valeur que `Sexe.Indetermine` de la lib. */
  Indetermine = 'indetermine',
}

export default Sexe;
